/* eslint-disable */
// a library to wrap and simplify api calls
import apisauce from 'apisauce'
import {Platform} from 'react-native'
import DebugConfig from '../Config/DebugConfig'
import { KargoeConfig } from '../Config/AppConfig'
//import RNFS from 'react-native-fs'
//import NetInfo from "@react-native-community/netinfo"
//import Ping from 'react-native-ping'
/*
How to write a fake API call:

const getShoppableConfig = () => new Promise(
  function(resolve, reject) {
    resolve({
      ok: true, // response.ok
      data: { // mock of Kargoe API response
        httpCode: 200,
        data: {
          headers: {
            Authorization: 'Bearer Mhav763IU3eZeAnKce2b7dee03850d04',
            cid: '1748811725.1492555146',
          },
          default: {
            merchants: [
              "Lord & Taylor",
              "Aspesi",
              "StyleBop",
            ],
          }
        }
      }
    })
  }
)
*/

const { appDetails } = KargoeConfig

// note:  post wall base has its own data cache because it uses xhr not this apisauce

const USE_DATA_CACHE = true

// --- kargoe cache init (OFFLINE USE ONLY)
let kargoecache = null
const INITIAL_STATS = {
  entries: null,
  bytes: null,
  writes: 0,
  updated: null,
  save: null,
  on: USE_DATA_CACHE,
}
let kargoeCacheStats = Object.assign({}, INITIAL_STATS)

let firstTimeWriteToKargoeCacheAPI = true

let apiReferenceCounter = 0

const apiCacheFile = /*RNFS.CachesDirectoryPath + */ '/cache.txt'

// read from cache file once per run at app launch (FOR OFFLINE USE ONLY)

if (kargoeCacheStats.on && (!kargoecache || Object.keys(kargoecache).length == 0)) {
  kargoecache = {}
  let path = apiCacheFile
  let t1 = Date.now()
  if (false)
  RNFS.readFile(path, 'utf8').then(res => {
    kargoecache = JSON.parse(res)
    kargoeCacheStats.entries = Object.entries(kargoecache).length
    kargoeCacheStats.bytes = res.length
    let t2 = Date.now()
    if (!kargoecache) kargoecache = {} // make sure it is an object not undefined
    //("did read the api cache, keys = " + Object.keys(kargoecache))

    console.log("did read & parse main cache time = " + (t2-t1))

  })
  .catch(e => {
    console.log("error reading cache " + JSON.stringify(e, null, 2))
  })
}

lastCacheWriteTime = 1 // scope?

let apiKeySimplify = function(key) {
  key = key.replace(/{/g,'_')
  key = key.replace(/}/g,'_')
  key = key.replace(/"/g,'_')
  key = key.replace(/'/g,'_')
  key = key.replace(/:/g,'_')
  return key
}
// --- end kargoe cache init

let pingStarted = false

async function kargoePing(api) { 

  // console.log("start of ping")

  try {
    /**
     *
     * Get RTT (Round-trip delay time)
     *
     * @static
     * @param {string} ipAddress - For example : 8.8.8.8
     * @param {Object} option - Some optional operations
     * @param {number} option.timeout - timeout
     * @returns
     * @memberof Ping
     */
    const ms = 0 // await Ping.start('172.217.4.78',{ timeout: 5000 }); // google addr for trial
    //console.log("api index " + api.referenceIndex + " ping " + ms);
    if (ms > 5000) {
      console.log("slow ping on api " + api.referenceIndex  + " mark offline")
      api.kargoeIsConnected = false // too slow man... ping should be fast or we are in trouble
    }
    else {
      //console.log("good ping set connected to true")
      api.kargoeIsConnected = true
    }

  } catch (error) {
    console.log('ping error on api ' + api.referenceIndex + ' mark offline ' + error.code + " " + error.message);
    api.kargoeIsConnected = false
  }

}

// this will store the first api created and the base url that was used to create it,
// so it can be re-used.  this assumes that the first api created is the "main" app api
// the one that sticks around throughout the app lifecycle.
// slight change would be required if this is not the case in the future.
let sharedApi = null
let sharedApiBaseURL = null

// our "constructor"
const create = (baseURL = KargoeConfig.baseUrlAPI) => {

  let apiCreate = null
  
  if (sharedApiBaseURL === baseURL && sharedApi) {
     console.log('re-using api for ' + baseURL + ' connected = ' + sharedApi.kargoeIsConnected)
     apiCreate = sharedApi
     kargoePing(apiCreate) // if we are first re-using the api, do an immediate ping see if we are connected
                           // or the first call to the api may go to wrong place (e.g. go to network even if no network is avail)
                           // fail case:  be on wall, turn to bad network (100% incoming packet loss), go immediately to
                           // happening (heart menu upper right)
  }
  
  else console.log('making new api for ' + baseURL)

  // ------
  // STEP 1
  // ------
  //
  // Create and configure an apisauce-based api object.
  //
  if (!apiCreate) {
    /*let*/ apiCreate = apisauce.create({
    // base URL is read from the "constructor"
    baseURL,
    // here are some default headers
    headers: {
      // 'Cache-Control': 'no-cache', // not allowed for web
      'Client-Name' : appDetails.userAgent,
      'Client-Version' : '1.90.1', // appDetails.appVersion,
      // 'Client-Device' : appDetails.clientDevice, // Apple iPhone 6s 12.3 (emulated)
      // iOS React Kargoe, version 0.0.1
    },
    // 10 second timeout...
    timeout: 50000 // 0000
  })

    apiReferenceCounter++

    apiCreate.referenceIndex = apiReferenceCounter
    console.log("setting connected to true loc 1")
    apiCreate.kargoeIsConnected = true // assume yes to start

  }

  // first time...
  let firstTime = false // for hooking up callback functions or not because they are already hooked up

  if (!sharedApi) {
    firstTime = true
    sharedApi = apiCreate // save for re-use
    sharedApiBaseURL = baseURL // save for re-use
  }
                    
  api = apiCreate

  // move up into create 
  // so if net is dead when new api is created, it has the true state right away
  // api.kargoeIsConnected = true // assume yes to start

  // in case we re-use this api, dont make another pinger or we get pingers all over the place
  if (!api.pingInterval) {
    kargoePing.call(this, api) // do immediately once, to start 
    api.pingInterval = setInterval(kargoePing.bind(this, api), 5000) // save interval in case we want to cancel it, but we dont know
  }

  if (false)
  NetInfo.fetch().then(state => {
    //console.log("Connection type", state.type);
    //console.log("Is connected?", state.isConnected);
    // defer, use ping instead:  
    // api.kargoeIsConnected = state.isConnected
  })

  // Subscribe (may want to subscribe if this object is destroyed, but how, we are not a component)
  if (false && !api.connectionListener) // in case of re-use dont make another listener
    api.connectionListener = NetInfo.addEventListener(state => {
    //console.log("connection state changed!")
    //console.log("Connection type", state.type);
    //console.log("Is connected?", state.isConnected);
      // defer, use ping instead:  
      console.log('loc 2 set connected to ' + state.isConnected)
    api.kargoeIsConnected = state.isConnected
  });

  // not used yet
  api.stopPing = () => {
     clearInterval(api.pingInterval)
     api.pingInterval = null
  }

  if (firstTime)
    api.openRequestList = []

  if (firstTime)
  api.addRequestTransform(request => {
    if (!request.url.includes('v1/log')) {
      //console.log(`addRequestTransform, request keys: ${JSON.stringify(Object.keys(request))}`)
      // ["url","params","method","headers"]
      const description = request.method + "/" + request.url
      if (request.method == 'get' && request.params && request.params.length)
        description += "/" + JSON.stringify(request.params).replace("\\", '')
      //console.log(`addRequestTransform desc ${description}`)
      api.openRequestList.push(description)
    }
    if (typeof api.openRequestCount == 'undefined')
      api.openRequestCount = 0
    api.openRequestCount++
  })

  if (firstTime)
  api.addMonitor(resp => {
    api.openRequestCount--
    if (api.openRequestCount == 0)
      api.openRequestList = []

    let path = apiCacheFile 

    //console.log("resp = " + JSON.stringify(resp, null, 2))
    // console.log(`addMonitor, resp keys: ${JSON.stringify(Object.keys(resp))}`)
    // ["duration","problem","ok","status","headers","config","data"]
    // console.log(`addMonitor, config keys: ${JSON.stringify(Object.keys(resp.config))}`)
    // resp.config keys: ["adapter","transformRequest","transformResponse","timeout","xsrfCookieName","xsrfHeaderName","maxContentLength","validateStatus","headers","baseURL","method","url","params","data"]

    // remove completed api call from open request list
    let apiUri = resp.config.method + "/" + resp.config.url.replace(KargoeConfig.baseUrlAPI, '')
    if (resp.config.method == 'get' && resp.config.params && resp.config.params.length)
      apiUri += "/" + JSON.stringify(resp.config.params).replace("\\", '')
    const indexOfDesc = api.openRequestList.indexOf(apiUri) // find oldest match
    if (indexOfDesc >= 0)
      api.openRequestList.splice(indexOfDesc, 1)

    if (!resp.config.url.includes('webapi/v1/log')) { // dont record duration of api log calls
      if (typeof api.previousGoodCount == 'undefined')
        api.previousGoodCount = 0
      if (resp.duration > 2000) { // 2000
        const duration = resp.duration / 1000
        const logRef = resp.data && resp.data.logRef ? resp.data.logRef : 'unknown'
        // we do not know the real list of open requests, cleared out when none are pending, because monitor is not passed the request!
        const msg = `MONITOR duration ${duration}s (resp dur > 2s), prev ok ${api.previousGoodCount}, app ${appDetails.appVersion}, logRef ${logRef}, ${apiUri}, open requests ${api.openRequestCount}, est open: ${JSON.stringify(api.openRequestList)}`
        console.log(msg) 
        // full for now
        log(msg) // use raw because we are in Api.js
      }
      else
        api.previousGoodCount++
    }

    // Update the OFFLINE karoge API cache (writes to disk every 20 seconds or so) 
    // **** MAYBE SHOULD ONLY SAVE 'GET' ****
    // console.log("docdir = " + path)
    if (!kargoecache) kargoecache = {}

    if (kargoeCacheStats.on && resp.ok) {

      let key = ""
      if (resp.config.params && Object.keys(resp.config.params).length > 0) 
        key = resp.config.url + JSON.stringify(resp.config.params)
      else
        key = resp.config.url

      // remove base url from key (or add it back on later when looking up cache but that may not be needed)
      key = key.replace(KargoeConfig.baseUrlAPI, '')

      key = apiKeySimplify(key)

      // console.log("storing cache key of " + key)

      if (firstTimeWriteToKargoeCacheAPI) {
        console.log('*** clearing API cache')
        kargoecache = {} // clear the pointer shared between api instantiations
        firstTimeWriteToKargoeCacheAPI = false
      }

      kargoecache[key] = resp

      //console.log("ready to write cache with keys " + JSON.stringify(Object.keys(kargoecache)))

      let t1 = Date.now()
      const writeEveryMs = 20000
      if (!lastCacheWriteTime) lastCacheWriteTime = 1
      // set first term to true to write every time
      if (false || ((t1 - lastCacheWriteTime) > writeEveryMs)) {
        lastCacheWriteTime = t1
        // maybe read write binary?

        let tA = Date.now()
        let cacheString = JSON.stringify(kargoecache)
        let tB = Date.now()

        //console.log("json stringify time for main cache write = " + (tB-tA) + " bytes = " + cacheString.length);

        console.log("api cache size is now " + cacheString.length)
        kargoeCacheStats.bytes = cacheString.length
        kargoeCacheStats.updated = tB
        kargoeCacheStats.entries = Object.entries(kargoecache).length
        kargoeCacheStats.writes++

        if (false)
        RNFS.writeFile(path, cacheString, 'utf8').then(resp => {
          // console.log("write cache ok full time = " + (Date.now() - t1))
          kargoeCacheStats.save = 'Success'
        })
        .catch(error => {
          console.log("error writing cache file " + JSON.stringify(error, null, 2))
          kargoeCacheStats.save = JSON.stringify(error, null, 2)
        })

      }

      //console.log("past write cache")
    }
    //else console.log("skip cache write, response not ok")

    //NotificationManager.postNotificationWithString("AppDelegate_printf", msg)
    //console.log("MONITOR RESPONSE = " + JSON.stringify(resp, null, 2)) 

    if( resp.data.errors ) {
      console.log(`API.js have errors: ` + JSON.stringify(resp.data.errors))
      resp.data.errors.forEach(err =>  {
        if( err.code === 107 && api.setState ) {
          api.setState({ outofdate : true })
        }
        if( err.code === 900 && api.setState ) {
          console.tron.log(`API.js setting needsLoginTimeStamp`)
          api.setState({ needsLoginTimeStamp : Date.now() })
        }
      })
    }
  })

  // if re-use api, this function recursive in a bad way if we do this again on re-use
  if (!api.getNet) api.getNet = api.get

  api.get = (url, params) => { // enough args?

     // pass thru to test
     //console.log('ready to call api.getNet ' + url)

     // return api.getFromCache(url) // test

     // this is async so get its status next time

     // maybe just ping regularly?
     // kargoePing() // this is async so won't get the answer till next round

     if (api.kargoeIsConnected) {
       //console.log("seems connected, try from network url = " + url + " params = " + params)
       //console.log(new Error().stack)
       return api.getNet(url, params)
     }
     else {
       //console.log("seems NOT connected, try from cache = " + url + " params = " + params)
       return api.getFromCache(url, params)
     }
     
  }

  api.getFromCache = (url, params)  => {

    //console.log("get from cache kargoecache url = " + url + " keys = " + JSON.stringify(Object.keys(kargoecache)))

    let key = ""

    if (params && Object.keys(params).length > 0)
      key = url + JSON.stringify(params)
    else 
      key = url

    key = apiKeySimplify(key)

    // console.log("trying to pull key = " + key)

    let cachedResponse = kargoecache[key]

    //console.log("cached response = " + JSON.stringify(cachedResponse, null, 2))

    const p1 = new Promise((resolve, reject) => { 
          
          if (cachedResponse) {
            //console.log('for key = ' + key + ' ready to resolve cached response ' + JSON.stringify(cachedResponse, null, 2))
            resolve(cachedResponse)
          }
          else {
            //console.log("cannot find cached response returning ok.false")
            resolve({ok: false})
          }
    });

    return p1 
  }
  
  const getCacheStats = () => {
    const temp = kargoeCacheStats
    return temp
  }
  const clearCache = () => {
    console.log("*** clearing api cache, called on logout as well")
    kargoeCacheStats = Object.assign({}, INITIAL_STATS, {on: kargoeCacheStats.on})
    kargoecache = {}
    api.setState({ needsLoginTimeStamp : null })
  }
  const enableCache = () => {
    kargoeCacheStats.on = true
  }
  const disableCache = () => {
    kargoeCacheStats.on = false
  }

  const getRoot = () => api.get('')
  const getRate = () => api.get('rate_limit')
  const getUser = (username) => api.get('search/users', { q: username })

  const signup = (username,
    password,
    firstName,
    lastName,
    email,
    termsOfUseAccepted,
    bio
  ) => api.post('v1/public/signup',
    {
      data: {
        Username: username,
        LastName: lastName,
        FirstName: firstName,
        Email: email,
        Password: password,
        TermsOfUseAccepted: true,
        Login: true,
        Bio:bio

      }
    }
  )
  const signup2 = (fields) => api.post('v1/public/signup', {data: fields})

  const login = (username, password) => api.post('v1/public/login', { Username: username, Password: password, appDetails })

  const changePassword = (oneTimeCode, password, confirmPassword) => api.post('v1/public/one_time_login', {
    login_code: oneTimeCode, Password: password, confirm_password: confirmPassword, appDetails
  })

  const loginFacebook = (data) => api.post('v1/public/login', {
    FacebookToken: data.facebookToken, FacebookUserId: data.facebookUserId, RedirectURI: false, appDetails
  })
  const signupFacebook = (data) => api.post('v1/public/signup', {
    data: {
      appDetails,
      Login: true,
      FacebookToken: data.facebookToken,
      FacebookUserId: data.facebookUserId,
      TermsOfUseAccepted: true,
      Username: data.username,
      Email:  data.email,
      Bio: data.bio,
      FirstName : data.firstName,
      LastName : data.lastName,
      Phone : data.phone
      }

  })
  const getFacebookStatus = () => api.get('v1/facebook/status')
  const getTmpUrl = (postId) => api.get('v1/post/'+ postId + '/temp-file-url?suffix=.jpg')
  const renewToken = (token) => api.put('v1/public/renew', { access_token: token })
  const deleteHashTag = (data) => api.put('v1/post/' + data.PostId, {data : {Tags:data.Tags,PostId:data.PostId}})
  const editHashtags = (PostId, Tags) => api.put('v1/post/' + PostId, {data : {Tags:Tags, PostId:PostId}})
  const resetPass = (email) => {
    console.log("in resetPass api:  resetPass email = " + email)
    let emailToSend = email
    if (typeof email !== 'string') { // funky stuff on web there may be a better way to do this, but for now...
      let keys = Object.keys(email)
      emailToSend = ''
      for (let i = 0; i < keys.length; i++) { // keys are "0", "1", etc as strings
        let char = email[i.toString()]
        if (typeof char != 'undefined')
        emailToSend = emailToSend + char
      }
    }
    console.log("resetPass email stringify = " + JSON.stringify(email))
    console.log("resetPass emailToSend = " + emailToSend)
    console.log("resetPass appDetails.urlScheme = " + appDetails.urlScheme)
    let promise = 
    api.post('v1/public/request_one_time_login', {
      Email  : emailToSend,
      // hard code for now, need to figure out routing back to change passwd page later
      Url    : (Platform.OS == 'web') ? 'https://kargoedev.herokuapp.com' : (appDetails.urlScheme + '://') , // 'kr go vn dev://', // see XCode > ignite1 > Info > URL Types > URL Schemes
      source : (Platform.OS == 'web') ? 'web-app' : 'app'
    })

    // web is handling this differently, what to do?
    if (Platform.OS == 'web') {

      promise.then((x) => {
        console.log("response from forgot passwd = " + JSON.stringify(x))
        if (x.ok && x.status == 202) {
            alert("Please check your email for a password reset link!  If you had mis-typed your email or username, you will not get an email response.")
        } else {
            alert("Our server was unable to process your reset password request, please check the email or username you typed and try again.")
        }
      }).catch((x) => {
        console.log("error from forgot passwd = " + JSON.stringify(x))
        alert("Our server had trouble with your reset password request, please try again later.")
      })

    }
  }
  const logout = () => api.delete('v1/public/logout')
  const setAuthorization = (token) => api.setHeader('Authorization', "Token " + token)
  const clearAuthorization = () => api.setHeader('Authorization', "")
  //const setLanguage = (language) => api.setHeader('language', language)
  const clearLanguage = () => api.deleteHeader('language')
	const log = (message) => api.get('v1/log', {message})
	

  const getGroup = () => api.get('v1/user-group', {})
  const addUserToGroup = (InvitingAccessToken) => api.post('v1/user-group', { InvitingAccessToken })
  const removeUserFromGroup = (userId) => api.delete('v1/user-group/' + userId)
  const switchToGroupUser = (userId) => api.put('v1/user-group/' + userId, {appDetails})


  const paypalStatus = (params) => api.get('v1/paypal/status', params)
  const paypalLogout = (params) => api.get('v1/social/logout', { service: 'paypal' })

  // FUTURE: cannot hook directly into readUser as it returns a promise
  const cacheSetUser = (userId, user) => {
    const cacheKey = `user/${userId}`
    if (user)
      api.cache.set(cacheKey, user, 300) // 5 minutes - there will be a delay in seeing new totals for auth, orders, tokens
    else
      api.cache.delete(cacheKey)
  }
  const cacheGetUser = (userId) => {
    const cacheKey = `user/${userId}`
    return api.cache.set(cacheKey)
  }
  const readUser = (userId) => api.get('v1/user/' + userId, {})
  // const getRelogin = (userId) => api.get('v1/user/' + userId, {})
  const updateUser = (changes) => api.put('v1/user/' + changes.UserId, { data: changes })
  // const setPushFlags = (changes) => api.put('v1/user/' + changes.UserId, { data: changes })
  // const addAddress = (address) => api.put('v1/user/' + address.UserId, { data: address })
  const readStore = (userId) => api.get('v1/store/' + userId, {})
  const avatar = ( ) => api.get('v1/avatar_url', { })
  const avatarUpdated = ( UserId ) => api.put(`v1/user/${UserId}/avatar-updated`, { })
  const createMyShopUrl = (ItemId, extension = 'jpg', index = 0) => api.get(`v2/post-they-sell-url/${ItemId}/${index}/${extension}`)
  const getmessages = () => api.get('v1/chat')
  const getUnreadMessages = () => api.get('v1/chat-unread')

  const getChatImageUrl = (chatId) => api.get('v1/chat-image/' + chatId )
  const getChat = (userId, start = 0, limit = 30) => api.get('v1/chat/' + userId + '/user', { start : start, limit : limit })
  const sendChat = (params) => api.post('v1/chat', { data: params })
  const markChatRead = (chatId) => api.put(`v1/chat/${chatId}`, { })
  const deleteChat = (data) => api.delete(`v1/chat/${data.ChatId}/${data.aTimeStamp}`, { })
  const typing = userId => api.put(`v1/chat/${userId}/typing`, { })

  const chatToken = () => api.get('v1/user/-1/chat_token', {})
  const repost = (post) => api.post('v1/post/' + post.PostId + '/repost', { data: post })
  const updatePost = (post) => api.put('v1/post/' + post.PostId, {
    data: post
  })
  const getPosts = (post) => api.get('v1/post', {
    UserId: post.userId,
    limit: post.limit,
    start: post.starts,
    end: post.end,
    video: post.video
  })
  const getPostsPeople = (data) => api.get('v1/post', {
    UserIds: data.userIds,
    limit: typeof data.limit == 'undefined' ? 10 : data.limit,
  })
  const getPostsDetail = (data) => api.get('v1/post/' + data.PostId, {
    PostIds: data.PostIds,
    GetLikes: true
  })
  const getPostTagDetail = (data) => api.get('v1/post/' + data.PostId + '/tag-details')
  const readPost = (data) => api.get('v1/post/' + data.PostId)
  
  const blockUser = (data) => api.post('v1/user/' +  data.userId + '/block/'  + data.blockUserId)
  const unBlockUser = (data) => api.delete('v1/user/' +  data.userId + '/block/'  + data.blockUserId)
  const getBlockUser = (data) => api.get('v1/user/' +  data.userId + '/blocking' )

  const readItem = (data) => api.get('v1/item/' + data.ItemId)
  const getLikePost = (data) => api.get('v1/search/liked-posts')
  const searchTagPost = (data) => api.get('v1/search/tag-posts', { tag: data.search })
  const getPopularUsers = ( ) => api.get('v1/users-popular', { limit: 200, pagination: true })
  const getOrderedUsers = start => api.get('v1/search/explora-ordered-user-ids', { start : start, limit : 100 })
  const getOrderEndorse = (data) => api.get('v1/order',
    {
      EndorserUserId: data.endorserUserId,
      completed: data.completed,
      limit: 100
    })
  const getOrderBought = (data) => api.get('v1/order',
    {
      PurchaserUserId: data.purchaserUserId,
      completed: data.completed,
      limit: 100
    })
  const getOrderSold = (data) => api.get('v1/order',
    {
      SellerUserId: data.sellerUserId,
      completed: data.completed,
      limit: 100
    })
  const getOrderDetail = (data) => api.get('v1/order/' + data.orderId, {})
  const shipProduct = (data) => api.put('v1/order/' + data.orderId + '/shipped', {
        Carrier: data.carrier,
        TrackingNumber: data.trackingNumber
  })
  const getOrderPostmates = (OrderId) => api.get(`v1/order/${OrderId}/track`, { })

  // orders/purchase
  const orderConfirm = (args, params) => api.post('v1/post/' + args.PostId + '/order-confirm/' + args.TagId, params)
  const purchase = (args, params) => api.post('v1/post/' + args.PostId + '/purchase', params)
  const orderPreflight = (args) => api.post('v1/post/' + args.PostId + '/order-preflight/' + args.TagId, {})

  const followUser = (userId, user2Id) => api.post('v1/user/' + userId + '/follow/' + user2Id, {})
  const unfollowUser = (userId, user2Id) => api.delete('v1/user/' + userId + '/follow/' + user2Id, {})
  // following : false ->>> phone user (aka 'Me')
  const getHappening = following => api.get('v1/activity', { following : following })
  const whoFollowMe = (start) => api.get('v1/activity', { following: false, limit: 20, start: start })

  const kargorHappening = () => api.get('v1/activity', {
    following: true,
    limit: 10
  })


  const getFollowersUser = (userId) => api.get('v2/user/' + userId + '/followers', { GetFollowing: "Yes" })
  const getFollowings = (userId,limit = 300) => api.get('v2/user/' + userId + '/following', { limit: limit, GetFollowing: "Yes" })
/*
  const getFollowing = ({ UserId, next }) => {
    var params = { limit : 300 }
    if( typeof next === 'string' || typeof next === 'number' ) params.start = next
    return api.get(`v2/user/${UserId}/following`, params)
  }
  const getFollowers = ({ UserId, next }) => {
    var params = { limit : 300 }
    if( typeof next === 'string' ) params.start = next
    return api.get(`v2/user/${UserId}/followers`, params)
  }
*/
  const getFollowing = (userId, params) => api.get('v2/user/' + userId + '/following', Object.assign({}, params, {GetFollowing: "Yes"}))
  const getFollowers = (userId, params) => api.get('v2/user/' + userId + '/followers', Object.assign({}, params, {GetFollowing: "Yes"}))

  const searchUser = (data) => api.get('v1/user-search', { limit: data.limit, search: data.user })
  const itemSearch = (options) => api.get('v1/search/item', options) // from, limit, filter, search
  const getKargoeTag = (data) => api.get('v1/search-recent/item',
    {
      limit: data.limit,
      filter: data.filter,
      search: data.search,
      options: typeof data.options != 'undefined' ? data.options : {}
    })
  const getSearchKargoeTag = (data) => api.get('v1/search/item',
    {
      pagination:true,
      limit: typeof data.limit == 'undefined' ? 10 : data.limit,
      search: data.search,
      filter: data.filter
    })
  const getPostByItem = (data, limit) => api.get('v1/item-posts/' + data.ItemId, { limit: limit||100 })

  const getCharities = () => api.get('v1/charity', {})
  const getPostAllLikes = (postId) => api.get('v1/post/' + postId + '/all-likes', {})
  const getPostComments = PostId => api.get('v1/post/' + PostId + '/comment', { })
  const postComment = (postId, body) => api.post('v1/post/' + postId + '/comment', { data: { Body: body ? body : '' } })
  const deleteComment = (postId, timestamp) => api.delete('v1/post/' + postId + '/comment/' + timestamp, {})

  const createPost = (data) => api.post('v2/post', { data : data })
  const completePost = (id) => api.put(`v2/post/${id}/complete`, { })
  const createStandardPost = (data) => api.post('v1/new-post', { data: data })
  const listPostFiles = (postID) => api.get('v1/post/' + postID + '/files', {})
  const finishPost = (postID) => api.put('v1/finish-post/' + postID, {})
  const deletePost = (postId) => api.delete('v1/post/' + postId, {})
  const reportPost = (data) => api.post('v1/post/' + data.postId + '/censor', {
      CensorState: "review",
      Reason: data.reason,
      Message: data.comment
  })

  const tagDetails = (postId) => api.get('v1/post/' + postId + '/tag-details', {})
  const preflightOrder = (postId, itemId) => api.get('v1/post/' + postId + '/order-preflight/' + itemId, {})
  const confirmOrder = (postId, itemId, params) => api.post('v1/post/' + postId + '/order-confirm/' + itemId, params)
  const purchaseOrder = (postId, params) => api.post('v1/post/' + postId + '/purchase', params)

  const lovePost = (postId) => api.post('v1/post/' + postId + '/like', {})
  const unlovePost = (postId) => api.delete('v1/post/' + postId + '/like', {})
  
  const streamStarting = (postId, message) => api.post('v1/stream-starting/' + postId, {message})

  const userCoupons = () => api.get('v1/coupon', {})
  const getOffer = (OfferId, Code) => api.get('v1/offer-search', {OfferId: OfferId, Code: Code})
  const redeemCoupon = (CouponId) => api.put('v1/coupon/' + CouponId, {data: {CouponId: CouponId, Redeemed: Date.now()/1000}})
  const vendorOffers = (UserId) => api.get('v1/offer-vendor', {UserId})
  const allOffers = () => api.get('v1/offer-all', {})
  
  const getCurrencyExchangeRates = () => api.get('v1/currency-exchange-rates', {})


  const saveCartDetail = (cart) => api.post('v1/shoppable/save_cart_detail', {data: Object.assign({}, cart, {appDetails})})

  const IAP = (receiptData) => api.post('v1/iap', {receiptData})
  const transferTokens = (receiverUserId, numTokens, postId) => api.put('v1/transfer-tokens/' + receiverUserId + '/' + numTokens + '/' + postId, {})

  const tokenLedger = (start, limit) => api.get(`v1/tokens?start=${start}&limit=${limit}`)

  // api in-memory cache, relatively short caching times
  if (typeof api.cache == 'undefined')
    api.cache = {
      data: {},
      // note:  cannot call api.cache.set outside api.js
      set(name, data, lifeSpanSeconds) {
        if (!name)
          return
        const expiresMS = Date.now() + lifeSpanSeconds * 1000
        console.log(`api.cache set ${name} lifeSpanSeconds ${lifeSpanSeconds} expires ${expiresMS}`)
        this.data[name] = [data, expiresMS]
      },
      delete(name) {
        console.log(`api.cache delete ${name}`)
        if (name && (typeof (this.data[name]) != 'undefined'))
          delete this.data[name]
      },
      deleteAll() {
        console.log(`api.cache delete all`)
        this.data = {} // switch users
      },
      get(name) {
        console.log(`api.cache get ${name}, cacheSize: ${Object.keys(this.data).length}`)
        if (name && (typeof (this.data[name]) != 'undefined')) {
          const entry = this.data[name]
          const data = entry[0]
          const expires = entry[1]
          if (expires > Date.now()) {
            console.log(`api.cache get found data`)
            return data
          }
          console.log(`api.cache get expired, expires ${expires}, now ${Date.now()}, difference ${expires - Date.now()}`)
          return null
        }
        console.log(`api.cache get did not find data`)
        return null
      }
    }

  const cacheSet = (name, data, lifeSpanSeconds) => api.cache.set(name, data, lifeSpanSeconds)
  const cacheDelete = (name) => api.cache.delete(name)
  const cacheDeleteAll = () => api.cache.deleteAll()
  const cacheGet = (name) => api.cache.get(name)

  // Shoppable API calls

  let shoppableApi = apisauce.create({
    baseURL: KargoeConfig.shoppable.apiUrl,
    headers: {
      // 'Cache-Control': 'no-cache', // not allowed for web (?)
    },
    timeout: 40000 // 40 second timeout...
  })
  api.reject = (reason='already getting') => Promise.reject({ error : reason })
  const getShoppableConfig = () => {
    if( this.gettingShoppableConfig ) return api.reject( )
    this.getting = true
    console.log(`api.cache calling v1/shoppable/config, Date.now ${Date.now()}`)
    return api.get('v1/shoppable/config', {})
    .then(
      resp => {
        this.getting = false
        if (resp.data.data.brands.length < 300)
          shoppableApi.allBrands = encodeURI(resp.data.data.brands.join(','))
        // console.tron.display({name: 'api.js', preview: `getShoppableConfig`, value: {resp, shoppableApiAllBrands: shoppableApi.allBrands}})
        return resp
      })
    .catch(err => {this.getting=false;return err})
  }
  const shoppableSetBaseURL = (url) => shoppableApi.setBaseURL(url)
  const shoppableSetHeaders = (headers) => shoppableApi.setHeaders(headers)
  const shoppableCatalog = (query) => {
    // disable April 1, 2020 because querying with too many brands causes Shoppable api server to fail
    // if (shoppableApi.allBrands && (typeof query.brands == 'string' && query.brands == ''))
    //  query.brands = shoppableApi.allBrands
    // console.tron.display({name: 'api.js', preview: `shoppableCatalog`, value: {query}})
    return shoppableApi.get('v3/catalog', query) // items
  }
  const shoppableProductsByPartNumber = (partNumbers) => partNumbers.length != 1 ?
    shoppableApi.get(`v3/product/?part_numbers=` + partNumbers.join(',')) :
    shoppableApi.get(`v3/product/${partNumbers[0]}`)

  // NOTE: probably may have to make these calls on a web view page, cookies?
  const shoppableCreateShoppingCart = () => shoppableApi.get('v3/cart', {})
  const shoppableAddToCart = (cartId, sku, quantity) => shoppableApi.get(`v3/cart/${cartId}/put/` + encodeURIComponent(sku) + `/qty/${quantity}`, {})
  // NOTE: there is no 'purchase' API call, the cart is brought up in a web view
  
  
// NOTE api.post('/users', { name: 'steve' }, { headers: { 'x-gigawatts': '1.21' } })
// # curl -v -H 'Authorization: Bearer jwt' "https://api.music.apple.com/v1/catalog/us/songs/203709340"
// https://api.music.apple.com/v1/catalog/us/search?term=blue%2Bmonday&limit=24

// Top Songs
// https://api.music.apple.com/v1/catalog/us/charts?types=songs%2Calbums%2Cplaylists&limit=36
// /v1/catalog/us/charts?chart=most-played&limit=36&types=songs

// https://is4-ssl.mzstatic.com/image/thumb/Music123/v4/cc/c2/34/ccc23410-3166-90b6-cc40-8a7698ae1a90/20UMGIM28169.rgb.jpg/{w}x{h}bb.jpeg
// https://is4-ssl.mzstatic.com/image/thumb/Music123/v4/cc/c2/34/ccc23410-3166-90b6-cc40-8a7698ae1a90/20UMGIM28169.rgb.jpg/100x100bb.jpeg

  let appleMusicAPI = apisauce.create({
    baseURL: 'https://api.music.apple.com/',
    headers: {
      // 'Cache-Control': 'no-cache',
    },
    timeout: 40000 // 40 second timeout...
  })
  const appleMusicToken = () => api.get('v1/apple-music-token')
  const appleMusicSetHeaders = (headers) => appleMusicAPI.setHeaders(headers)
  const appleMusicTopSongs = () => appleMusicAPI.get('v1/catalog/us/charts', Object.assign({chart: 'most-played', types: 'songs', limit: 25}))
  const appleMusicSearch = (search, params) => appleMusicAPI.get('v1/catalog/us/search', Object.assign({term: search, limit: 25}, params))
  
  // print "curl -v -H 'Authorization: Bearer %s' \"https://api.music.apple.com/v1/catalog/us/search?term=genesis&limit=24\" " % (token)

  // ------
  // STEP 3
  // ------
  //
  // Return back a collection of functions that we would consider our
  // interface.  Most of the time it'll be just the list of all the
  // methods in step 2.
  //
  // Notice we're not returning back the `api` created in step 1?  That's
  // because it is scoped privately.  This is one way to create truly
  // private scoped goodies in JavaScript.
  //
  return {
    api,
    shoppableApi,
    // a list of the API functions from step 2
    getRoot,
    getRate,
    getUser,
    signup,
    signup2,
    login,
    changePassword,
    setAuthorization,
    clearAuthorization,
    //setLanguage,
    clearLanguage,
    paypalStatus,
    paypalLogout,
    whoFollowMe,
    kargorHappening,
    readUser,
    readStore,
    // setPushFlags,
    updateUser,
    // addAddress,
    avatar,
    avatarUpdated,
    createMyShopUrl,
    renewToken,
    followUser,
    unfollowUser,
    orderConfirm,
    purchase,
    orderPreflight,
    logout,
    log,
    getPosts,
    // getRelogin,
    getmessages,

    getChat,
    getUnreadMessages,
    sendChat,
    markChatRead,
    deleteChat,
    typing,

    chatToken,
    getFollowersUser,
    getFollowings,
    getFollowing,
    getFollowers,
    getPopularUsers,
    getOrderedUsers,
    getPostsPeople,
    searchUser,
    itemSearch,
    getKargoeTag,
    getPostByItem,
    getSearchKargoeTag,
    getPostsDetail,
    readPost,
    readItem,
    getLikePost,
    searchTagPost,
    getCharities,
    getPostTagDetail,
    getPostAllLikes,
    getPostComments,
    postComment,
    deleteComment,
    createPost,
    completePost,
    createStandardPost,
    listPostFiles,
    finishPost,
    deletePost,
    repost,
    updatePost,
    tagDetails,
    preflightOrder,
    confirmOrder,
    purchaseOrder,
    lovePost,
    unlovePost,
    getOrderEndorse,
    getOrderBought,
    getOrderSold,
    getOrderDetail,
    getOrderPostmates,
    shipProduct,
    resetPass,
    loginFacebook,
    signupFacebook,
    reportPost,
    getFacebookStatus,
    getTmpUrl,
    deleteHashTag,
    editHashtags,
    blockUser,
    unBlockUser,
    getBlockUser,
    userCoupons,
    getOffer,
    redeemCoupon,
    vendorOffers,
    allOffers,
    getCurrencyExchangeRates,
    saveCartDetail,
    getShoppableConfig,
    getHappening,
    shoppableSetHeaders,
    shoppableSetBaseURL,
    shoppableCatalog,
    shoppableProductsByPartNumber,
    shoppableCreateShoppingCart,
    shoppableAddToCart,
    getChatImageUrl,
    getCacheStats,
    clearCache,
    enableCache,
    disableCache,
    appleMusicToken,
    appleMusicSetHeaders,
    appleMusicTopSongs,
		appleMusicSearch,
		getGroup,
		switchToGroupUser,
		addUserToGroup,
		removeUserFromGroup,
    streamStarting,
    IAP,
    transferTokens,
    tokenLedger,
    cacheSet,
    cacheDelete,
    cacheDeleteAll,
    cacheGet,
    }
}

// let's return back our create method as the default.
export default {
  create
}


export const API_GET_HAPPENING = `${KargoeConfig.baseUrlAPI}v1/activity`
